import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Name the Fear",
    opening: localizedGenderNode(
      [
      "Today I do not fight the fear of failure.",
      "I only notice: it is here."
    ],
      [
      "Today I do not fight the fear of failure.",
      "I only notice: it is here."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When is this fear strongest?",
      "What scenario appears right away?",
      "What do I feel in my body?"
    ],
      [
      "When is this fear strongest?",
      "What scenario appears right away?",
      "What do I feel in my body?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Fear is an experience, not a fact."
    ],
      [
      "Fear is an experience, not a fact."
    ]
    ),
    action: localizedGenderNode(
      "one breath + \"I see the fear\".",
      "one breath + \"I see the fear\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "The First Moment",
    opening: localizedGenderNode(
      [
      "Today I notice the moment the fear begins.",
      "I only notice."
    ],
      [
      "Today I notice the moment the fear begins.",
      "I only notice."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I sit with myself for a moment.",
      "One breath."
    ],
      [
      "I sit with myself for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What happens right before it rises?",
      "Where am I when it starts?",
      "What am I afraid will happen?"
    ],
      [
      "What happens right before it rises?",
      "Where am I when it starts?",
      "What am I afraid will happen?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "In the first moment I have a little space."
    ],
      [
      "In the first moment I have a little space."
    ]
    ),
    action: localizedGenderNode(
      "one breath when the fear starts.",
      "one breath when the fear starts."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Body Signals",
    opening: localizedGenderNode(
      [
      "Today I listen to my body before the story.",
      "I stay with myself."
    ],
      [
      "Today I listen to my body before the story.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice my breath.",
      "One breath."
    ],
      [
      "I notice my breath.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Where does the tension sit in my body?",
      "What is my body trying to protect?",
      "What could soften a little?"
    ],
      [
      "Where does the tension sit in my body?",
      "What is my body trying to protect?",
      "What could soften a little?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "My body is trying to protect me."
    ],
      [
      "My body is trying to protect me."
    ]
    ),
    action: localizedGenderNode(
      "a hand on my chest and one breath.",
      "a hand on my chest and one breath."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Story vs. Fact",
    opening: localizedGenderNode(
      [
      "Today I separate fact from story.",
      "I do not fight the story."
    ],
      [
      "Today I separate fact from story.",
      "I do not fight the story."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe in and out.",
      "One breath."
    ],
      [
      "I breathe in and out.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What is the bare fact here?",
      "What story jumped in?",
      "What softer possibility could also be true?"
    ],
      [
      "What is the bare fact here?",
      "What story jumped in?",
      "What softer possibility could also be true?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A story is not me."
    ],
      [
      "A story is not me."
    ]
    ),
    action: localizedGenderNode(
      "an inner sentence - \"This is a story rising\".",
      "an inner sentence - \"This is a story rising\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "The Fear Beneath",
    opening: localizedGenderNode(
      [
      "Today I touch the fear beneath failure.",
      "I stay with it for a moment."
    ],
      [
      "Today I touch the fear beneath failure.",
      "I stay with it for a moment."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "One breath."
    ],
      [
      "I breathe slowly.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What am I afraid will happen?",
      "What hurts most in that thought?",
      "What do I need to hear now?"
    ],
      [
      "What am I afraid will happen?",
      "What hurts most in that thought?",
      "What do I need to hear now?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Fear wants protection, not a fight."
    ],
      [
      "Fear wants protection, not a fight."
    ]
    ),
    action: localizedGenderNode(
      "name the fear quietly.",
      "name the fear quietly."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "The Inner Voice",
    opening: localizedGenderNode(
      [
      "Today I listen to the voice that warns me.",
      "Without fighting it."
    ],
      [
      "Today I listen to the voice that warns me.",
      "Without fighting it."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice my inner voice.",
      "One breath."
    ],
      [
      "I notice my inner voice.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How does that voice sound?",
      "What is it trying to protect?",
      "What would I like to say to it?"
    ],
      [
      "How does that voice sound?",
      "What is it trying to protect?",
      "What would I like to say to it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A voice is just a voice."
    ],
      [
      "A voice is just a voice."
    ]
    ),
    action: localizedGenderNode(
      "notice it without believing it.",
      "notice it without believing it."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "The Need for Safety",
    opening: localizedGenderNode(
      [
      "Today I touch the need for safety beneath the fear.",
      "I stay with myself."
    ],
      [
      "Today I touch the need for safety beneath the fear.",
      "I stay with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "One breath."
    ],
      [
      "I breathe slowly.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I need to feel safe?",
      "What can help me keep going despite the fear?",
      "What would I like to give myself now?"
    ],
      [
      "What do I need to feel safe?",
      "What can help me keep going despite the fear?",
      "What would I like to give myself now?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A little safety changes the tone."
    ],
      [
      "A little safety changes the tone."
    ]
    ),
    action: localizedGenderNode(
      "write one safety word.",
      "write one safety word."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Set It Down for a Moment",
    opening: localizedGenderNode(
      [
      "Today I see how it feels to set the fear down for a moment.",
      "Just a moment."
    ],
      [
      "Today I see how it feels to set the fear down for a moment.",
      "Just a moment."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I let my body soften a little.",
      "One breath."
    ],
      [
      "I let my body soften a little.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What happens in me when I set it down?",
      "What scares me about setting it down?",
      "What calms me even a little?"
    ],
      [
      "What happens in me when I set it down?",
      "What scares me about setting it down?",
      "What calms me even a little?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Setting it down for a moment is also a choice."
    ],
      [
      "Setting it down for a moment is also a choice."
    ]
    ),
    action: localizedGenderNode(
      "one moment without fighting the fear.",
      "one moment without fighting the fear."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "A Soft Inner Language",
    opening: localizedGenderNode(
      [
      "Today I choose to speak to myself gently.",
      "Not by force."
    ],
      [
      "Today I choose to speak to myself gently.",
      "Not by force."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe and notice my inner voice.",
      "One breath."
    ],
      [
      "I breathe and notice my inner voice.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "How do I speak to myself when I fear failure?",
      "How would I like to hear it?",
      "What is my gentle sentence?"
    ],
      [
      "How do I speak to myself when I fear failure?",
      "How would I like to hear it?",
      "What is my gentle sentence?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A gentle voice lowers pressure."
    ],
      [
      "A gentle voice lowers pressure."
    ]
    ),
    action: localizedGenderNode(
      "say the gentle sentence once.",
      "say the gentle sentence once."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "A Moment Before Giving Up",
    opening: localizedGenderNode(
      [
      "Today I pause a moment before I give up.",
      "Just a moment."
    ],
      [
      "Today I pause a moment before I give up.",
      "Just a moment."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice the urge to give up.",
      "One breath."
    ],
      [
      "I notice the urge to give up.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What am I trying to avoid?",
      "What happens if I continue a little?",
      "What can support me for one moment?"
    ],
      [
      "What am I trying to avoid?",
      "What happens if I continue a little?",
      "What can support me for one moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small moment changes direction."
    ],
      [
      "A small moment changes direction."
    ]
    ),
    action: localizedGenderNode(
      "one breath before giving up.",
      "one breath before giving up."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Return to the Present",
    opening: localizedGenderNode(
      [
      "Today I return to this moment.",
      "I am with myself."
    ],
      [
      "Today I return to this moment.",
      "I am with myself."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I feel the weight of my body.",
      "One breath."
    ],
      [
      "I feel the weight of my body.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I hear right now?",
      "What do I see around me?",
      "What do I feel in this moment?"
    ],
      [
      "What do I hear right now?",
      "What do I see around me?",
      "What do I feel in this moment?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "The present gives me ground."
    ],
      [
      "The present gives me ground."
    ]
    ),
    action: localizedGenderNode(
      "feel my feet for a moment.",
      "feel my feet for a moment."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "A Moment Before Trying",
    opening: localizedGenderNode(
      [
      "Today I pause a moment before trying.",
      "Just a moment."
    ],
      [
      "Today I pause a moment before trying.",
      "Just a moment."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I notice the urge to stop.",
      "One breath."
    ],
      [
      "I notice the urge to stop.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I want to try?",
      "What scares me about it?",
      "What small step is possible for me?"
    ],
      [
      "What do I want to try?",
      "What scares me about it?",
      "What small step is possible for me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small try is movement."
    ],
      [
      "A small try is movement."
    ]
    ),
    action: localizedGenderNode(
      "phrase one small try.",
      "phrase one small try."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "A Small Step",
    opening: localizedGenderNode(
      [
      "Today I choose a small step that returns me to myself.",
      "Not a revolution."
    ],
      [
      "Today I choose a small step that returns me to myself.",
      "Not a revolution."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly and look around.",
      "One breath."
    ],
      [
      "I breathe slowly and look around.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small step can help me try?",
      "When can I do it?",
      "What will help me remember?"
    ],
      [
      "What small step can help me try?",
      "When can I do it?",
      "What will help me remember?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Small enough is enough."
    ],
      [
      "Small enough is enough."
    ]
    ),
    action: localizedGenderNode(
      "choose one small step.",
      "choose one small step."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Return Sentence",
    opening: localizedGenderNode(
      [
      "Today I finish with a sentence that returns me to myself.",
      "I choose presence."
    ],
      [
      "Today I finish with a sentence that returns me to myself.",
      "I choose presence."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause a moment before response.",
      "One breath."
    ],
      [
      "I pause a moment before response.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about this fear?",
      "What is the first sign it rises?",
      "What is my short sentence?"
    ],
      [
      "What did I learn about this fear?",
      "What is the first sign it rises?",
      "What is my short sentence?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I choose a moment before response."
    ],
      [
      "I choose a moment before response."
    ]
    ),
    action: localizedGenderNode(
      "one breath + my sentence.",
      "one breath + my sentence."
    ),
  },
].map(buildNormalizedDay);

export const fearOfFailureBlueprintEn = buildNormalizedPilotBlueprint({
  id: "fear_of_failure_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "fear_of_failure",
  category: "anxiety",
  journeyName: {
    he: "פחד מכישלון",
    en: "Fear of failure",
    es: "Miedo al fracaso",
  },
  days,
});

export default fearOfFailureBlueprintEn;
